import {
  all, call, put, select,
} from 'redux-saga/effects';
import api from 'store/api';
import { toast } from 'react-toastify';
import { URL } from '../../../constants/url';
import {
  normalizePostflopGame,
  normalizePostflopStatPosition,
} from '../../../utils/postflopPosition';
import { getPostflopResultsStat } from '../actions';
import { getRequestRevision, isCurrentRequest, requestMeta } from '../requestState';
import watchRequest from './requestLifecycle';
import { calculateResultsSummary, getSummaryPositions } from '../../../pages/PostflopResults/summary';

const isPlo5Payload = (payload = {}) => (
  typeof payload.isPlo5 === 'boolean'
    ? payload.isPlo5
    : sessionStorage.getItem('isPlo5') === 'true'
);

const defineEndpoint = (isPlo5) => {
  if (isPlo5) return URL.PLO5_POSTFLOP_STAT;
  return URL.POSTFLOP_STAT;
};

export function* getResultsStatGen({ payload = {} }) {
  const revision = yield select(getRequestRevision('resultsStat'));
  const meta = requestMeta('resultsStat', revision);
  const isPlo5 = isPlo5Payload(payload);

  try {
    const request = {
      method: 'post',
      url: defineEndpoint(isPlo5),
      data: {
        game: normalizePostflopGame(payload.game, isPlo5),
        bb: payload.bb,
        position_type: payload.position_type,
        position: normalizePostflopStatPosition(
          payload.position_type,
          payload.position,
          payload.game,
        ),
        board_type: payload.board_type,
        hand_combo_type: payload.hand_combo_type || '',
      },
    };
    const res = yield call(api, request);

    if (!(yield select(isCurrentRequest('resultsStat', revision)))) return;
    if (!res?.data || typeof res.data !== 'object') throw new Error('Results could not be loaded. Please try again.');
    // Each read returns the saved all-time best for one spot/situation. Reuse
    // the selected result and fetch the rest together; no session is written.
    const positions = getSummaryPositions({ ...payload, ...request.data, isPlo5 });
    const remaining = positions.filter((position) => position !== request.data.position);
    const responses = yield all(remaining.map((position) => call(api, {
      ...request,
      data: { ...request.data, position },
    })));
    if (!(yield select(isCurrentRequest('resultsStat', revision)))) return;
    if (responses.some((response) => !response?.data || typeof response.data !== 'object')) {
      throw new Error('Results could not be loaded. Please try again.');
    }
    const groupResults = responses.map((response) => response.data);
    if (positions.includes(request.data.position)) groupResults.push(res.data);
    yield put({
      ...getPostflopResultsStat.success({
        average: res?.data?.average || [],
        best: res?.data?.best || [],
        group_best_average: res?.data?.group_best_average || 0,
        ...calculateResultsSummary(groupResults),
      }),
      meta,
    });
  } catch (e) {
    if (!(yield select(isCurrentRequest('resultsStat', revision)))) return;
    yield put({ ...getPostflopResultsStat.error(e.message), meta });
    yield call(toast.error, e.message);
  }
}

export default function* listener() {
  yield* watchRequest('resultsStat', getResultsStatGen);
}
